import * as React from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "../../lib/cn";
import type { BreadcrumbItem } from "./types";

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  /** Render prop for router-aware links */
  renderLink?: (href: string, label: string) => React.ReactNode;
  className?: string;
}

export function Breadcrumb({ items, renderLink, className }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className={cn("flex items-center gap-1.5 text-sm", className)}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" aria-hidden="true" />}
            {isLast || !item.href ? (
              <span className={cn(isLast ? "font-medium text-gray-900" : "text-gray-500")}>
                {item.label}
              </span>
            ) : renderLink ? (
              renderLink(item.href, item.label)
            ) : (
              <a href={item.href} className="text-gray-500 hover:text-gray-700 transition-colors">
                {item.label}
              </a>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
